import './Home.css'
import React from 'react'

const Bar = () => {
  return <div className="chatroom">Chat Room</div>
}

export default Bar
